module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ops-support/merchant-clean-up/merchant-clean-up.component.less
// module id = 1197
// module chunks = 0